<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M1.6665 3.33335C1.6665 2.96516 1.96498 2.66669 2.33317 2.66669H13.6665C14.0347 2.66669 14.3332 2.96516 14.3332 3.33335V12.6667C14.3332 13.0349 14.0347 13.3334 13.6665 13.3334H2.33317C1.96498 13.3334 1.6665 13.0349 1.6665 12.6667V3.33335Z"
      stroke="#696D69" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M4.8335 6C5.10963 6 5.3335 5.77613 5.3335 5.5C5.3335 5.22387 5.10963 5 4.8335 5C4.55736 5 4.3335 5.22387 4.3335 5.5C4.3335 5.77613 4.55736 6 4.8335 6Z"
      stroke="#696D69" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M4.99984 8L6.6665 9.33333L8.6665 7L14.3332 11.3333V12.6667C14.3332 13.0349 14.0347 13.3333 13.6665 13.3333H2.33317C1.96498 13.3333 1.6665 13.0349 1.6665 12.6667V11.3333L4.99984 8Z"
      stroke="#696D69" stroke-width="1.4" stroke-linejoin="round" />
  </svg>
</template>
